import { createFileRoute } from '@tanstack/react-router';
import Settings from '@Views/Settings';

export const Route = createFileRoute('/settings/_layout')({
    component: Settings,
});
